import { useState, useCallback, useRef } from 'react';
import { API_URL } from '../Config';

export function useVideo(projectId, videoUrl, setVideoUrl, updateProject) {
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await fetch(`${API_URL}/upload-video/${projectId}`, {
          method: 'POST',
          body: formData,
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data.videoUrl;
      } catch (error) {
        console.error("Error uploading video:", error);
        alert("Error uploading video. Check console for details.");
      }
    }
  };

  const handleResetVideo = () => {
    if (videoUrl) {
      URL.revokeObjectURL(videoUrl);
    }
    setVideoUrl(null);
    updateProject(null);
  };

  const handleProgress = () => {
    if (videoRef.current) {
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      setDuration(videoRef.current.duration);
    }
  };

  const handleSeek = (time) => {
    if (videoRef.current) {
      videoRef.current.currentTime = time;
      setCurrentTime(time);
    }
  };

  return { 
    videoUrl, 
    videoRef, 
    currentTime, 
    duration, 
    isPlaying, 
    handleFileChange, 
    handleResetVideo, 
    handleProgress, 
    handleLoadedMetadata, 
    handleSeek,
    setIsPlaying 
  };
}